import React, { Component , Fragment } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

class CounterOne extends Component {
    // Estado para controlar la animación al hacerse visible
    state = {
        didViewCountUp: false
    };

    // Función que cambia el estado cuando el componente es visible
    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({ didViewCountUp: true });
        }
    }

    render() {
        // Datos de ejemplo para los contadores (REEMPLAZAR CON DATOS REALES DE LA AGENCIA CUANDO SEA POSIBLE)
        let Data = [
            {
                countNum : 53, // Número a mostrar
                // Título descriptivo en español
                countTitle: 'Clientes Satisfechos que Confían en Nuestro Trabajo',
            },
            {
                countNum : 85, // Número a mostrar
                // Título descriptivo en español
                countTitle: 'Proyectos Exitosos Entregados',
            },
            {
                countNum : 130, // Número a mostrar
                 // Título descriptivo en español
                countTitle: 'Estrategias Digitales Implementadas',
                // Podrías añadir un cuarto si lo deseas, por ejemplo:
                // countNum: 25,
                // countTitle: 'Marcas Impulsadas desde Cero'
            },
            // Puedes añadir o quitar elementos según necesites (idealmente 3 o 4 para buen diseño)
        ];

        return (
            <Fragment>
                <div className="row">
                    {/* Mapea los datos para crear cada contador */}
                    {Data.map((value, index) => (
                        <div className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                            <h5 className="counter">
                                {/* Sensor de visibilidad para activar la animación solo cuando se ve */}
                                <VisibilitySensor onChange={this.onVisibilityChange} offset={{ top: 10 }} delayedCall>
                                    {/* Componente que anima el número */}
                                    <CountUp end={this.state.didViewCountUp ? value.countNum : 0} />
                                </VisibilitySensor>
                                {/* Puedes añadir un símbolo si es relevante, ej: '+' o '%' */}
                                {/* Ejemplo: <CountUp end={...} />+ */}
                            </h5>
                            {/* Muestra el título descriptivo */}
                            <p className="description">{value.countTitle}</p>
                        </div>
                    ))}
                </div>
            </Fragment>
        );
    }
}
export default CounterOne;